import { FilterMatchMode } from 'primereact/api';
import { Badge } from 'primereact/badge';

export const ClienteAlerta = {
    identificacion: {
        header: 'Identificación',
        table: true,
        sort: true,
        filter: true,
        matchMode: FilterMatchMode.CONTAINS,
        filterPlaceholder: 'Buscar por ID',
        style: { width: '25%' },
        body: (rowData) => (
            <span className="font-semibold text-gray-700">{rowData.identificacion}</span>
        )
    },
    nombres: {
        header: 'Cliente',
        table: true,
        sort: true,
        filter: true,
        matchMode: FilterMatchMode.CONTAINS,
        filterPlaceholder: 'Buscar Cliente',
        style: { width: '55%' },
        body: (rowData) => (
            <div className="flex align-items-center gap-2">
                <div className="surface-200 border-circle p-1 flex justify-content-center align-items-center" style={{ width: '28px', height: '28px' }}>
                    <i className="pi pi-user text-600 text-sm"></i>
                </div>
                <span className="text-gray-800">{rowData.nombres}</span>
            </div>
        )
    },
    total_alertas: {
        header: 'Registros',
        table: true,
        sort: true,
        filter: true,
        isNumeric: true,
        matchMode: FilterMatchMode.EQUALS,
        style: { width: '20%', textAlign: 'center' },
        headerStyle: { justifyContent: 'center' },
        body: (rowData) => {
            let severity = 'info';
            if (rowData.total_alertas > 5) severity = 'danger';
            else if (rowData.total_alertas > 2) severity = 'warning';

            return (
                <div className="flex justify-content-center">
                    <Badge value={rowData.total_alertas} severity={severity} size="large" className="shadow-1" />
                </div>
            );
        }
    }
};